import { useEffect, useState } from "react";
import axios from "axios";
import EarningsData from "./EarningsData";
import { Spinner } from "@heroui/spinner";

export default function EarningsCalendar({ stockSymbol }) {
  // Initialize state variables for stock data
  const [earningsCalendarData, setEarningsCalendarData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const fetchStockData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post('/api/company/earnings-calendar', { ticker: stockSymbol }, {
            headers: {
              'Content-Type': 'application/json'
            }
          });

        if (!response.status === 200) {
          throw new Error("Network response was not ok");
        }

        const data = await response.data;
        setEarningsCalendarData(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching stock data:", error);
        setIsLoading(false);
      }
    };

    fetchStockData();
  }, [stockSymbol]);

  // Loading condition
  if (
    !earningsCalendarData && !stockSymbol
  ) {
      <div className="flex justify-center items-center h-full">
          Not available for this company.
      </div>;
  }

  if(isLoading) {
    return <div className="flex justify-center items-center h-full">
          <Spinner color="primary" />
      </div>
  }

  return (
    <div className="flex justify-center items-center h-full">
      <EarningsData earnings={earningsCalendarData} />
    </div>
  );
}
